// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SystemListApiParameter, SystemListCollectionModel } from "@synd/App/Services/SystemListService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type SystemListState = {
    [key: string]: SystemListCollectionModel;
};

const initialSystemListState: SystemListState = {};

const xSystemList = createTypedReducerWithImmer(initialSystemListState, {
    "xSystemLists/CompleteLoadSystemList": (
        draft: Draft<SystemListState>,
        action: { parameter: SystemListApiParameter; systemList: SystemListCollectionModel },
    ) => {
        draft[action.parameter.name] = action.systemList!;
    },
});

(reducers as any).xSystemList = xSystemList;

export type xSystemListState = {
    xSystemList: SystemListState;
} & ApplicationState;

type xSystemListReducers = {
    systemList: typeof xSystemList;
};

export type xSystemListActions = Parameters<xSystemListReducers[keyof xSystemListReducers]>[1] | AnyAction;
